import { v4 as uuidv4 } from 'uuid';


const specialItem = [
  {
    "name": "Chicken Biryani",
    "price": [150, 290],
    "isVeg": false,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
  {
    "name": "Creamy Dal Makhni",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
  {
    "name": "Lemon bread",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
  {
    "name": "Mutton Biryani",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
  {
    "name": "Samosa",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
  {
    "name": "Veg Biryani",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Chef's special",
    "id": uuidv4()
  },
]

export default specialItem;